import React, { useMemo } from "react";
import { View, StyleSheet, Platform } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { ROUTES } from "../shared/constants/routes";
import { useTranslation } from "react-i18next";
import { useNavigation } from "@react-navigation/native";
import { useActiveTabStore } from "../store/activeTabStore";
import { ButtonVariant } from "./CustomButton";
import getGlobalStyles from "../globalStyles";
import { usePlatform } from "../providers/PlatformProvider";
import { useThemeSettings } from "../ThemeProvider";
import { TrackedButton } from "../analytics/components";
import TourStep from "./productTours/TourStep";

export default function HomeScreenHeader() {

  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  const navigation = useNavigation<any>();
  const activetab = useActiveTabStore((state) => state.activetab);
  const { showWebVersion } = usePlatform();
  const tabs: { key: any, name: string, label: string }[] = [
    { key: ROUTES.READ, name: 'book', label: t("screens.home.read") },
    { key: ROUTES.LISTEN, name: 'podcast', label: t("screens.home.listen") },
    { key: ROUTES.WATCH, name: 'watch', label: t("screens.home.watch") },
  ];
  return (
    <View style={[styles.container, !showWebVersion && gStyles.fullWidthWithMargin]}>
      <View style={styles.row}>
        {/* Toggle Buttons */}
        <TourStep order={1}>
          <View style={styles.toggleContainer} id="tabSwitch">
            {tabs.map((tab) => {
              return <TrackedButton key={tab.key} iconSize={24} context={{ cta: 'CHANGE_TAB', selected_tab: activetab, change_to: tab.key }}
                variant={activetab === tab.key ? ButtonVariant.NORMAL_PRIMARY : ButtonVariant.TRANSPARENT}
                icon={tab.name!}
                labelStyle={activetab !== tab.key && { color: theme?.colors?.primaryLight }}
                onPress={() => navigation.navigate(ROUTES.HOME, { selectedTab: tab.key })}
              >{activetab === tab.key ? tab.label : ''}
              </TrackedButton>
            })}

          </View>
        </TourStep>
        {/* Right Icons */}
        <View style={styles.iconRow}>
          <Ionicons name="notifications-outline" size={22} color="#fff" />
          <Ionicons name="settings-outline" size={22} color="#fff" style={{ marginLeft: 16 }} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: Platform.OS === 'web' ? 10 : 55,
    paddingBottom: 10,
    marginHorizontal: 20,
    alignSelf: 'center'
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  toggleContainer: {
    flexDirection: "row",
    padding: 4,
    justifyContent: 'space-around'
  },

  iconRow: {
    flexDirection: "row",
    alignItems: "center",
    display: 'none'
  },
});